import { useCompanyId } from '@startuptools/common/react-wrapper';
import { useMeetingAttendanceListSuspenseQuery } from './AttendanceList.graphql';
import { groupBy } from 'lodash-es';
import { Card } from '@startuptools/ui/Card';
import { Stack } from '@startuptools/ui/Stack';
import { Table } from '@startuptools/ui/Table';
import { Typography } from '@startuptools/ui/Typography';
import { Trans } from '@lingui/react';
import { Identity } from '@startuptools/business-ui/identity/Identity';
import { type GqlMeetingParticipant } from '../../../graphql/base-types.graphql';

const MeetingParticipantFunctionHuman = ({
  mp,
}: {
  mp: Pick<GqlMeetingParticipant, 'chairman' | 'secretary' | 'adjuster'>;
}) => {
  const f = [];
  if (mp.chairman) {
    f.push(<Trans id="Chairman" />);
  }
  if (mp.secretary) {
    f.push(<Trans id="Secretary" />);
  }
  if (mp.adjuster) {
    f.push(<Trans id="Verifier" />);
  }
  return f.map((e, i) => (
    <>
      {e}
      {f.length - 1 > i && ', '}
    </>
  ));
};

export const MeetingAttendanceList = ({ meetingId }: { meetingId: string }) => {
  const companyId = useCompanyId();
  const {
    data: { meetingParticipants },
  } = useMeetingAttendanceListSuspenseQuery({
    variables: { companyId, meetingId },
    fetchPolicy: 'cache-and-network',
  });

  const attendees = groupBy(meetingParticipants.models, mp => (mp.present ? 'present' : 'absent'));

  return (
    <Card>
      <Stack gap={1}>
        <Typography level="title-md">
          <Trans id="Attended" />
        </Typography>
        <Table>
          <tbody>
            {/*
             // @ts-expect-error TS2532 */}
            {attendees['present'].map(mp => (
              <tr key={mp.id}>
                <td>
                  <Identity identity={mp.identity} />
                </td>
                <td>{mp.proxy && <Identity identity={mp.proxy} />}</td>
                <td>
                  <MeetingParticipantFunctionHuman mp={mp} />
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Stack>
      {/*
       // @ts-expect-error TS2532 */}
      {attendees['absent']?.length > 0 && (
        <Stack gap={1}>
          <Typography level="title-md">
            <Trans id="Absent" />
          </Typography>
          <Table>
            <tbody>
              {/*
               // @ts-expect-error TS2532 */}
              {attendees['absent'].map(mp => (
                <tr key={mp.id}>
                  <td>
                    <Identity identity={mp.identity} />
                  </td>
                  <td>{mp.proxy && <Identity identity={mp.proxy} />}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Stack>
      )}
    </Card>
  );
};
